export default (props) => (
  /**
   * Ícone "x" utilizado para limpeza
   * da url de requisição no geoserviço.
   */  
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      y1="-0.75"
      x2="13"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 15.0674 5.57031)"
      stroke="#C4C4C4"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="13"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 5.87512 4.36328)"
      stroke="#C4C4C4"
      strokeWidth="1.5"
    />
  </svg>
);
